import { useForm } from 'react-hook-form';
import sweetAlert from 'sweetalert2';
import iconUser from '../images/login/icon_user.png';
import iconPass from '../images/login/icon_pass.png';
import { ApolloError, gql, useMutation } from '@apollo/client';
import { loginMutation, loginMutationVariables } from './dtos/loginMutation';
import { useHistory } from 'react-router-dom';
import { isLoggedInVar, jwtToken } from '../../apollo';
import { SESSIONSTORAGE_TOKEN } from '../../components/constants';
//interface는 I로 시작하게 하면 직관적으로 알 수 있다.

//mutation LoginMutation($email: String!, $password: String!) 이 줄은 모두 frontend를 위한거다
//mutation 뒤의 이름은 Front에서만 확인하는 변수다. $뒤에 입력하는 이름은 아폴로에게 알려주는 변수명이다.
//playground에 입력하는대로 그대로 적으면 된다.
const LOGIN_MUTATION = gql`
    mutation loginMutation($loginInput: LoginInput!) {
        login(input: $loginInput) {
            success
            message
            token
        }
    }
`;

interface ILoginForm {
    email: string;
    password: string;
}

function Login() {
    const history = useHistory();
    const { register, watch, errors, handleSubmit, getValues } = useForm<ILoginForm>();
    //console.log(watch('email')); //ref={register}로 등록해주면 email 이라는 input name의 Element를 관찰합니다.
    //Email 란에 입력하는대로 console.log가 열심히 찍힘 (ex:비밀번호 몇자이상 등 유효성 검사를 위해 watch를 해야함)

    const onCompleted = async (data: loginMutation) => {
        const {
            login: { success, message, token },
        } = data;
        if (success && token) {
            sessionStorage.setItem(SESSIONSTORAGE_TOKEN, token);
            jwtToken(token);
            isLoggedInVar(true);
            await sweetAlert.fire({
                title: '성공',
                html: `${message}`,
                icon: 'success',
                confirmButtonText: '확인',
            });

            history.push('/');
        } else {
            sweetAlert.fire({
                title: '실패',
                html: `${message}`,
                icon: 'error',
            });
        }
    };
    //const onError = (error: ApolloError) => {};

    const [loginMutation, { data: loginMutationResult }] = useMutation<loginMutation, loginMutationVariables>(
        LOGIN_MUTATION,
        {
            onCompleted,
            //onError,
        },
    );

    const onSubmit = () => {
        const { email, password } = getValues();
        loginMutation({
            variables: {
                loginInput: {
                    email,
                    password,
                },
            },
        });
    };
    //console.log(errors.email?.message);
    const reg_email = /^([0-9a-zA-Z_\.-]+)@([0-9a-zA-Z_-]+)(\.[0-9a-zA-Z_-]+){1,2}$/; //이메일 형식 체크 정규식
    const reg_pw = /^(?=.*[a-zA-Z])(?=.*[!@#$%^*+=\-,\\.<>/\\?~\\(\\)\\_\\[\]\\{\\}\\|;:])(?=.*[0-9]).{8,}$/; // 비밀번호 체크 정규식 (영문+숫자+특문조합 8자 이상)
    return (
        <div id="loginscss">
            <div id="containerH">
                <div className="loginArea">
                    <form className="loginForm" onSubmit={handleSubmit(onSubmit)}>
                        <div>
                            {/* <img alt="" src={iconUser} /> */}
                            <input
                                name="email"
                                type="email"
                                placeholder="이메일 아이디"
                                // defaultValue="test" //고정값
                                ref={register({ required: true, maxLength: 50, pattern: reg_email })} // 유효성 체크를 위한 조건을 넣어준다
                            />
                            {/* // 유효성 체크에 걸렸을 때 에러 문구를 설정해 준다 */}
                            {errors.email && errors.email.type === 'required' && <p>이메일은 필수 입력 항목입니다. </p>}
                            {errors.email && errors.email.type === 'maxLength' && (
                                <p>이메일의 최대 길이를 초과하였습니다.(최대 30자) </p>
                            )}
                            {errors.email && errors.email.type === 'pattern' && <p>올바른 이메일 형식이 아닙니다.</p>}
                        </div>
                        <div>
                            {/* <img alt="" src={iconPass} /> */}
                            <input
                                name="password"
                                type="password"
                                placeholder="비밀번호"
                                ref={register({ required: true, minLength: 8, pattern: reg_pw })}
                            />
                            {errors.password && errors.password.type === 'required' && (
                                <p>비밀번호는 필수 입력 항목입니다. </p>
                            )}
                            {errors.password && errors.password.type === 'minLength' && (
                                <p>비밀번호는 8자 이상 입력해 주시기 바랍니다. </p>
                            )}
                            {errors.password && errors.password.type === 'pattern' && (
                                <p>비밀번호는 영문+숫자+특수문자 조합 8자 이상 입력해 주시기 바랍니다. </p>
                            )}
                        </div>

                        <button type="submit" onClick={handleSubmit(onSubmit)}>
                            로그인
                        </button>
                    </form>
                </div>
            </div>
        </div>
    );
}

export default Login;
